import useOnClickOutside from "hooks/useOnClickOutside";
import { useRef, useState } from "react";
import { FaChevronRight, FaChevronLeft } from "react-icons/fa";
import { animated, useSpring } from "react-spring";
import styled from "styled-components";

export type ToolboxProps = {
  children: React.ReactNode;
};

const HideButton = styled.button`
  position: absolute;
  border: 1px solid transparent;
  right: 0;
  box-shadow: 3px 0 3px rgba(0, 0, 0, 0.14);
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
  border-left: 0;
  top: 60px;
  width: 30px;
  height: 32px;
  background-color: ${(props) => props.theme.colors.background};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:active,
  &:focus {
    outline: 0;
    border-color: ${(props) => props.theme.colors.primary};
  }
  @media (min-width: ${(props) => props.theme.breakpoints[0]}) {
    display: none;
  }
`;

const Container = styled(animated.div)`
  display: flex;
  flex-direction: column;
  width: 230px;
  flex: 0 0 230px;
  position: fixed;
  z-index: 1000;
  min-height: 100%;
  max-height: 100vh;
  height: 100vh;
  top: 0;
  left: 0;
  overflow-y: auto;
  @media (min-width: ${(props) => props.theme.breakpoints[0]}) {
    position: static;
    transform: none !important;
    padding-top: 0;
    margin-right: -12px;
    max-height: calc(100vh - 50px);
  }
`;

const Panel = styled.div`
  display: flex;
  flex-direction: column;
  width: 200px;
  flex: 0 0 200px;
  padding-left: 6px;
padding-right: 6px;
  box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.3);
  background: ${(props) => props.theme.colors.background};
  min-height: 100%;
  max-height: 100vh;
  padding-top 60px;
  @media (min-width: ${(props) => props.theme.breakpoints[0]}) {
    position: static;
    transform: none !important;
    padding-top: 10px;
  max-height: calc(100vh - 60px);
  }
`;

export function Toolbox({ children }: ToolboxProps) {
  const containerRef = useRef<HTMLDivElement>(null!);
  const [open, setOpen] = useState<boolean>(false);

  useOnClickOutside(containerRef, () => {
    setOpen(false);
  });

  const props = useSpring({
    transform: `translate3d(${open ? 0 : -200}px, 0px, 0px)`,
  });

  return (
    <Container style={props} ref={containerRef}>
      <HideButton onClick={() => setOpen(!open)}>
        {open ? <FaChevronLeft /> : <FaChevronRight />}
      </HideButton>
      <Panel>{children}</Panel>
    </Container>
  );
}
